<template>
    <div class="onboarding-page">
      <div class="text-center">
        <h1>CREATAI.CO</h1>
        <h2>
          <span class="static-text">WHERE</span>
          <span class="dynamic-text" ref="slogan"></span>
        </h2>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "OnboardingPage",
    mounted() {
      this.startTypingAnimation();
    },
    methods: {
      startTypingAnimation() {
        const slogans = [
          "CREATIVITY BECOMES REALITY.",
          "REALITY IS YOUR CREATIVITY.",
          "IDEAS TURN INTO POSSIBILITY.",
          "IMAGINATION SHAPES INFINITY.",
          "YOUR VISION FINDS ITS IDENTITY.",
        ];
        const element = this.$refs.slogan;
        let i = 0;
        let j = 0;
        let isDeleting = false;
  
        const type = () => {
          const current = slogans[j];
          const displayedText = isDeleting
            ? current.substring(0, i--)
            : current.substring(0, i++);
  
          element.textContent = displayedText;
  
          const typingSpeed = isDeleting ? 50 : 100;
  
          if (!isDeleting && i === current.length) {
            isDeleting = true;
            setTimeout(type, 2000); // Pause before deleting
          } else if (isDeleting && i === 0) {
            isDeleting = false;
            j = (j + 1) % slogans.length; // Move to the next slogan
            setTimeout(type, 500); // Pause before typing the next slogan
          } else {
            setTimeout(type, typingSpeed);
          }
        };
  
        type();
      },
    },
  };
  </script>
  
  <style scoped>
  /* Background Animation */
  .onboarding-page {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 100vh;
    background: radial-gradient(circle, #3b82f6, #10b981, #6366f1, #f97316, #db2777);
    background-size: 200% 200%;
    animation: dancingColors 10s infinite alternate;
    color: #ffffff;
    text-transform: uppercase;
    font-family: "Montserrat", sans-serif;
  }
  
  @keyframes dancingColors {
    0% {
      background-position: 0% 50%;
    }
    25% {
      background-position: 50% 0%;
    }
    50% {
      background-position: 100% 50%;
    }
    75% {
      background-position: 50% 100%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  
  /* Text Styling */
  .text-center {
    text-align: center;
    padding: 0 1rem;
  }
  
  h1 {
    font-size: 3.5rem;
    font-weight: 900; /* Increased font weight for extra boldness */
    letter-spacing: 0.25rem;
    margin: 0;
  }
  
  h2 {
    font-size: 1.5rem;
    font-weight: 800; /* Bold dynamic text */
    margin-top: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2rem; /* Prevent layout shift */
    overflow: hidden;
    white-space: nowrap;
  }
  
  .static-text {
    margin-right: 0.5rem;
  }
  
  .dynamic-text {
    font-weight: 800;
  }
  
  /* Responsive Design */
  @media (max-width: 768px) {
    h1 {
      font-size: 2.5rem;
      letter-spacing: 0.2rem;
    }
  
    h2 {
      font-size: 1.25rem;
    }
  }
  
  @media (max-width: 480px) {
    h1 {
      font-size: 2rem;
      letter-spacing: 0.15rem;
    }
  
    h2 {
      font-size: 1rem;
    }
  }
  </style>
  